


































import Vue from "vue";
import AppDialog from "~/components/AppDialog.vue";
import ObjectParser from "~/helper/ObjectParser";


const DEFAULT_CENTER = {name: '', city: '', country: '', province: null}
export default Vue.extend({
  components: {
    AppDialog
  },
  data: () => ({
    center: {...DEFAULT_CENTER}
  }),
  methods: {
    doesCenterHaveEmptyFields() {
      const obj: any = {...this.center};
      delete obj.province; // Province is optional so we don't care if its empty
      return ObjectParser.hasEmptyFields(obj);
    },
    async handleAdd() {
      try {
        await this.$axios.post(`center/`, this.center)
        this.center = {...DEFAULT_CENTER}
        this.$toast.success("Center successfully created");
        this.$emit('added');
      } catch (e) {
        this.$toast.error(e.response.data.message);
      }
    }
  }
})
